import React from 'react'
import { observer } from 'mobx-react'
import { useStores } from 'presentation/hooks/use-stores'
import HeadingNew from 'presentation/shared/components/HeadingNew'
import ScheduledSurgeriesDataGrid from 'presentation/hospital/components/Tables/ScheduledSurgeriesDataGrid'
import * as S from './styles'

const HospitalScheduledSurgeriesLayout = observer(() => {
  const currentHospital = useStores().currentHospital.actualHospital

  return (
    <S.Wrapper>
      <HeadingNew size="xlarge" color="primary600" lineHeight="large">
        Cirurgias agendadas
        {/* {currentHospital?.friendly_name} */}
      </HeadingNew>
      <ScheduledSurgeriesDataGrid
        currentHospitalId={currentHospital!.hospital_id}
      />
    </S.Wrapper>
  )
})

export default HospitalScheduledSurgeriesLayout
